export default "__VITE_ASSET__CJnnhW0O__"